import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { MotoristasComponent } from './motoristas.component';
import { MotoristasRoutingModule } from "./motoristas-routing.module";
import { MotoristaFormComponent } from './motorista-form/motorista-form.component';
import { MotoristaListComponent } from './motorista-list/motorista-list.component';
import { MotoristaApiService } from "./shared/motorista-api.service";
import { MotoristaNavigationService } from "./shared/motorista-navigation.service";
import { FuncionariosModule } from "../funcionarios/funcionarios.module";
import { MotoristaService } from "./shared/motorista.service";

@NgModule({
  imports: [
    SharedModule,
    FuncionariosModule,
    MotoristasRoutingModule
  ],
  providers: [
    MotoristaApiService,
    MotoristaNavigationService,
    MotoristaService
  ],
  declarations: [
    MotoristasComponent,
    MotoristaFormComponent,
    MotoristaListComponent
  ]
})
export class MotoristasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/motoristas.module.ts
 **/